"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _pdfLib = require("pdf-lib");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var MAX_PDF_SIZE = 50000000;
var validator = {
  cpf: function cpf(_cpf) {
    _cpf = _cpf.replace(/[^\d]+/g, "");
    if (_cpf == "") return false;
    // Elimina CPFs invalidos conhecidos
    if (_cpf.length != 11 || _cpf == "00000000000" || _cpf == "11111111111" || _cpf == "22222222222" || _cpf == "33333333333" || _cpf == "44444444444" || _cpf == "55555555555" || _cpf == "66666666666" || _cpf == "77777777777" || _cpf == "88888888888" || _cpf == "99999999999") return false;
    // Valida 1o digito
    var add = 0;
    for (var i = 0; i < 9; i++) add += parseInt(_cpf.charAt(i)) * (10 - i);
    var rev = 11 - add % 11;
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(_cpf.charAt(9))) return false;
    // Valida 2o digito
    add = 0;
    for (var _i = 0; _i < 10; _i++) add += parseInt(_cpf.charAt(_i)) * (11 - _i);
    rev = 11 - add % 11;
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(_cpf.charAt(10))) return false;
    return true;
  },
  cnpj: function cnpj(_cnpj) {
    _cnpj = _cnpj || "";
    _cnpj = _cnpj.replace(/[^\d]+/g, "");
    if (_cnpj == "") return false;
    if (_cnpj.length != 14) return false;
    if (_cnpj == "00000000000000" || _cnpj == "11111111111111" || _cnpj == "22222222222222" || _cnpj == "33333333333333" || _cnpj == "44444444444444" || _cnpj == "55555555555555" || _cnpj == "66666666666666" || _cnpj == "77777777777777" || _cnpj == "88888888888888" || _cnpj == "99999999999999") {
      return false;
    }
    var tamanho = _cnpj.length - 2;
    var numeros = _cnpj.substring(0, tamanho);
    var digitos = _cnpj.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) return false;
    tamanho = tamanho + 1;
    numeros = _cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (var _i2 = tamanho; _i2 >= 1; _i2--) {
      soma += numeros.charAt(tamanho - _i2) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) return false;
    return true;
  },
  nif: function nif(contribuinte) {
    var temErro = 0;
    if (contribuinte.substr(0, 1) != "1" &&
    // pessoa singular
    contribuinte.substr(0, 1) != "2" &&
    // pessoa singular
    contribuinte.substr(0, 1) != "3" &&
    // pessoa singular
    contribuinte.substr(0, 2) != "45" &&
    // pessoa singular não residente
    contribuinte.substr(0, 1) != "5" &&
    // pessoa colectiva
    contribuinte.substr(0, 1) != "6" &&
    // administração pública
    contribuinte.substr(0, 2) != "70" &&
    // herança indivisa
    contribuinte.substr(0, 2) != "71" &&
    // pessoa colectiva não residente
    contribuinte.substr(0, 2) != "72" &&
    // fundos de investimento
    contribuinte.substr(0, 2) != "77" &&
    // atribuição oficiosa
    contribuinte.substr(0, 2) != "79" &&
    // regime excepcional
    contribuinte.substr(0, 1) != "8" &&
    // empresário em nome individual (extinto)
    contribuinte.substr(0, 2) != "90" &&
    // condominios e sociedades irregulares
    contribuinte.substr(0, 2) != "91" &&
    // condominios e sociedades irregulares
    contribuinte.substr(0, 2) != "98" &&
    // não residentes
    contribuinte.substr(0, 2) != "99" // sociedades civis
    ) {
      temErro = 1;
      console.log(temErro);
    }
    var check1 = contribuinte.substr(0, 1) * 9;
    var check2 = contribuinte.substr(1, 1) * 8;
    var check3 = contribuinte.substr(2, 1) * 7;
    var check4 = contribuinte.substr(3, 1) * 6;
    var check5 = contribuinte.substr(4, 1) * 5;
    var check6 = contribuinte.substr(5, 1) * 4;
    var check7 = contribuinte.substr(6, 1) * 3;
    var check8 = contribuinte.substr(7, 1) * 2;
    var total = check1 + check2 + check3 + check4 + check5 + check6 + check7 + check8;
    var divisao = total / 11;
    var modulo11 = total - parseInt(divisao) * 11;
    var comparador;
    if (modulo11 == 1 || modulo11 == 0) {
      comparador = 0;
    } else {
      comparador = 11 - modulo11;
    }
    var ultimoDigito = contribuinte.substr(8, 1) * 1;
    if (ultimoDigito != comparador) {
      return false;
    }
  },
  email: function email(value) {
    var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !!re.test(value.toLowerCase());
  },
  url: function url(value) {
    // var regexQuery = "^((http|https)://)(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$";
    var regexQuery = "^(ht|f)tp(s?)://[0-9a-zA-Z]([-.w]*[0-9a-zA-Z])*(:(0-9)*)*(/?)([a-zA-Z0-9-.?,'/\\+&amp;%$#_+.=$*@!?:]*)?$";
    var url = new RegExp(regexQuery, "i");
    return url.test(value);
  },
  /**
   * @param {File[]} files
   * @param {boolean} mergeAttachments
   * @returns {Promise<string>}
   */
  pdf: function () {
    var _pdf = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(files, mergeAttachments) {
      var totalSize, firstFileName, _iterator, _step, _loop, _ret;
      return _regenerator["default"].wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            totalSize = 0;
            firstFileName = "";
            _iterator = _createForOfIteratorHelper(files.entries());
            _context2.prev = 3;
            _loop = /*#__PURE__*/_regenerator["default"].mark(function _loop() {
              var _step$value, i, file, fileBuffer, pdfDoc, pdfForm, pdfFields, _iterator2, _step2, pdfField, pdfSignature;
              return _regenerator["default"].wrap(function _loop$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _step$value = (0, _slicedToArray2["default"])(_step.value, 2), i = _step$value[0], file = _step$value[1];
                    if (!(!file.name.endsWith(".pdf") && file.type !== "application/pdf")) {
                      _context.next = 3;
                      break;
                    }
                    return _context.abrupt("return", {
                      v: "O arquivo \"".concat(file.name, "\" n\xE3o \xE9 um PDF. O sistema aceita somente arquivos PDF.")
                    });
                  case 3:
                    totalSize += file.size;
                    if (!(i === 0)) {
                      _context.next = 10;
                      break;
                    }
                    firstFileName = file.name;
                    if (!(totalSize > MAX_PDF_SIZE)) {
                      _context.next = 8;
                      break;
                    }
                    return _context.abrupt("return", {
                      v: "O arquivo \"".concat(file.name, "\" excede o tamanho m\xE1ximo permitedo (50MB) e n\xE3o pode ser utilizado para criar um processo.")
                    });
                  case 8:
                    _context.next = 12;
                    break;
                  case 10:
                    if (!(totalSize > MAX_PDF_SIZE && mergeAttachments)) {
                      _context.next = 12;
                      break;
                    }
                    return _context.abrupt("return", {
                      v: "O arquivo \"".concat(firstFileName, "\", juntamente com os anexos, excede o tamanho m\xE1ximo permitedo (50MB) e n\xE3o pode ser utilizado para criar um processo, a n\xE3o ser que voc\xEA desmarque a op\xE7\xE3o de unir os anexos.")
                    });
                  case 12:
                    _context.prev = 12;
                    _context.next = 15;
                    return new Promise(function (resolve, reject) {
                      var reader = new FileReader();
                      reader.readAsArrayBuffer(file);
                      reader.onload = function () {
                        return resolve(reader.result);
                      };
                      reader.onerror = function (err) {
                        return reject(err);
                      };
                    });
                  case 15:
                    fileBuffer = _context.sent;
                    _context.next = 18;
                    return _pdfLib.PDFDocument.load(fileBuffer);
                  case 18:
                    pdfDoc = _context.sent;
                    pdfForm = pdfDoc.getForm();
                    pdfFields = pdfForm.getFields();
                    _iterator2 = _createForOfIteratorHelper(pdfFields);
                    _context.prev = 22;
                    _iterator2.s();
                  case 24:
                    if ((_step2 = _iterator2.n()).done) {
                      _context.next = 37;
                      break;
                    }
                    pdfField = _step2.value;
                    _context.prev = 26;
                    pdfSignature = pdfForm.getSignature(pdfField.getName());
                    if (!pdfSignature) {
                      _context.next = 30;
                      break;
                    }
                    return _context.abrupt("return", {
                      v: "O arquivo \"".concat(file.name, "\" j\xE1 foi assinado digitalmente e n\xE3o pode ser utilizado para criar um processo.")
                    });
                  case 30:
                    _context.next = 35;
                    break;
                  case 32:
                    _context.prev = 32;
                    _context.t0 = _context["catch"](26);
                    console.log(_context.t0);
                  case 35:
                    _context.next = 24;
                    break;
                  case 37:
                    _context.next = 42;
                    break;
                  case 39:
                    _context.prev = 39;
                    _context.t1 = _context["catch"](22);
                    _iterator2.e(_context.t1);
                  case 42:
                    _context.prev = 42;
                    _iterator2.f();
                    return _context.finish(42);
                  case 45:
                    _context.next = 52;
                    break;
                  case 47:
                    _context.prev = 47;
                    _context.t2 = _context["catch"](12);
                    if (!(_context.t2.message && _context.t2.message.includes("encrypted"))) {
                      _context.next = 51;
                      break;
                    }
                    return _context.abrupt("return", {
                      v: "O arquivo \"".concat(file.name, "\" est\xE1 bloqueado e n\xE3o pode ser utilizado para criar um processo.")
                    });
                  case 51:
                    return _context.abrupt("return", {
                      v: "N\xE3o foi poss\xEDvel carregar o arquivo \"".concat(file.name, "\". Verifique se ele est\xE1 corrompido.")
                    });
                  case 52:
                  case "end":
                    return _context.stop();
                }
              }, _loop, null, [[12, 47], [22, 39, 42, 45], [26, 32]]);
            });
            _iterator.s();
          case 6:
            if ((_step = _iterator.n()).done) {
              _context2.next = 13;
              break;
            }
            return _context2.delegateYield(_loop(), "t0", 8);
          case 8:
            _ret = _context2.t0;
            if (!((0, _typeof2["default"])(_ret) === "object")) {
              _context2.next = 11;
              break;
            }
            return _context2.abrupt("return", _ret.v);
          case 11:
            _context2.next = 6;
            break;
          case 13:
            _context2.next = 18;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t1 = _context2["catch"](3);
            _iterator.e(_context2.t1);
          case 18:
            _context2.prev = 18;
            _iterator.f();
            return _context2.finish(18);
          case 21:
            return _context2.abrupt("return", "");
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee, null, [[3, 15, 18, 21]]);
    }));
    function pdf(_x, _x2) {
      return _pdf.apply(this, arguments);
    }
    return pdf;
  }(),
  /** @param {any} value */
  date: function date(value) {
    return value instanceof Date && !Number.isNaN(value.getTime());
  }
};
var _default = validator;
exports["default"] = _default;